import { Carousel } from '@mantine/carousel';
import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import ToolCard from '../ToolCard/ToolCard';
import { Wrapper } from './ToolsCarousel.style';

export type ToolsCarouselProps = {
  items: Json[];
};

export function ToolsCarousel(props: ToolsCarouselProps) {
  const { items } = props;
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const slides = items.map((item) => (
    <Carousel.Slide key={item.title}>
      <ToolCard item={item} />
    </Carousel.Slide>
  ));

  return (
    <Wrapper className='ToolsCarousel-wrapper' data-testid='ToolsCarousel-wrapper'>
      <Carousel
        slideSize={{ base: '100%', sm: '33%' }}
        slideGap={{ base: 2, sm: 'xl' }}
        align='start'
        slidesToScroll={mobile ? 1 : 2}
      >
        {slides}
      </Carousel>
    </Wrapper>
  );
}

export default ToolsCarousel;
